import { useState, useEffect } from "react";
import { carregarJustificativasDaModalidade, carregarJustificativasDoNucleo } from "../firebase";
import { intervaloDoMes } from "../leituras";
import { AZUL, TEXTO, CINZA_ESC, BRANCO } from "../tema";

// Consulta SÓ LEITURA das justificativas de falta pedidas pelos atletas.
// Não aprova nem nega nada. Em dois recortes:
//
//   completo (auxiliar técnico)  o pedido inteiro: o que foi alegado, o
//                                estado e o documento anexado, se houver.
//
//   abonadas (preparação física) só quem teve a falta abonada, sem o
//                                motivo e sem o documento.
//
// O segundo recorte existe porque a preparação física precisa saber QUEM
// está abonado e em QUE dia, para acertar a frequência do treino físico.
// Por que o atleta faltou é dado de saúde na maior parte dos casos, e o
// setor não precisa dele para fazer o que precisa fazer. Mostrar o motivo
// "porque a tela já tinha" espalha informação médica por conveniência de
// implementação.
//
// Todas as justificativas, e não só as com anexo: atestado é anexo, e a
// maior parte dos pedidos chega sem um. Filtrando por anexo, a aba mostrava
// 9 dos 49 pedidos do núcleo e o BMX aparecia vazio.
//
// modalidade ausente significa TODAS as modalidades do núcleo, que é como a
// preparação física usa esta tela: ela atende a turma inteira.
export default function SecaoComprovantes({ userNucleo, modalidade, somenteAbonadas = false }) {
  const todasAsModalidades = !modalidade;
  const [lista, setLista] = useState(null);
  const [erro, setErro] = useState(null);
  // Um mês por vez. A consulta é do período, e o histórico fica a um clique
  // de distância: eram 95 solicitações do núcleo a cada abertura, e elas se
  // acumulam mês a mês.
  const [mes, setMes] = useState(() => new Date().toISOString().slice(0, 7));

  useEffect(() => {
    let vivo = true;
    if (!userNucleo) { setLista([]); return; }
    setLista(null); setErro(null);
    const [ano, m] = (mes || "").split("-").map(Number);
    const periodo = mes ? intervaloDoMes(m - 1, ano) : null;

    (todasAsModalidades
      ? carregarJustificativasDoNucleo(userNucleo, periodo)
      : carregarJustificativasDaModalidade(userNucleo, modalidade, periodo))
      .then(l => {
        if (!vivo) return;
        setLista(somenteAbonadas
          ? l.filter((s) => String(s.status || "").toLowerCase() === "aprovada")
          : l);
      })
      .catch(() => { if (vivo) { setErro("Não foi possível carregar as justificativas."); setLista([]); } });
    return () => { vivo = false; };
  }, [userNucleo, modalidade, todasAsModalidades, somenteAbonadas, mes]);

  function fmtData(iso) {
    if (!iso) return "—";
    const p = String(iso).split("-");
    return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : iso;
  }
  const STATUS_ROTULO = { pendente: "Pendente", aprovada: "Abonada", aprovado: "Abonada", negada: "Negada", negado: "Negada", complemento: "Complemento pedido", resolvida: "Resolvida" };
  const STATUS_COR = { pendente: "#D97706", aprovada: "#059669", aprovado: "#059669", negada: "#DC2626", negado: "#DC2626", complemento: "#1E40AF", resolvida: "#1D6FA4" };

  const pendentes = (lista || []).filter((x) => (x.status || "pendente").toLowerCase() === "pendente").length;

  return (
    <div>
      <div style={{ fontWeight: 800, fontSize: 16, color: TEXTO, marginBottom: 4 }}>
        {somenteAbonadas ? "Faltas abonadas" : "Justificativas"} · {modalidade || "todas as modalidades"}
      </div>
      <div style={{ fontSize: 13, color: CINZA_ESC, marginBottom: 16, lineHeight: 1.5 }}>
        {somenteAbonadas
          ? "Faltas já justificadas e abonadas pela coordenação, de todas as modalidades. Serve para acertar a frequência do treino físico: o atleta abonado no treino da modalidade também está abonado aqui. O motivo não aparece — o setor precisa saber quem e quando, não por quê."
          : todasAsModalidades
            ? "Justificativas de falta pedidas pelos atletas do núcleo, de todas as modalidades, com ou sem documento anexado. Consulta apenas, a análise é feita pela coordenação."
            : "Justificativas de falta pedidas pelos atletas da sua modalidade, com ou sem documento anexado. Consulta apenas, a análise é feita por quem decide."}
      </div>

      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 14 }}>
        <span style={{ fontSize: 12.5, color: CINZA_ESC, fontWeight: 600 }}>Mês</span>
        <input type="month" value={mes} onChange={(e) => setMes(e.target.value)}
          style={{ padding: "6px 10px", borderRadius: 10, border: "1px solid #D1D5DB", fontSize: 13, fontFamily: "inherit" }} />
        {mes ? (
          <button onClick={() => setMes("")}
            style={{ background: "none", border: "none", cursor: "pointer", color: AZUL, fontSize: 12.5, fontWeight: 700 }}>
            ver todos os meses
          </button>
        ) : (
          <button onClick={() => setMes(new Date().toISOString().slice(0, 7))}
            style={{ background: "none", border: "none", cursor: "pointer", color: AZUL, fontSize: 12.5, fontWeight: 700 }}>
            voltar ao mês
          </button>
        )}
      </div>

      {Array.isArray(lista) && lista.length > 0 && (
        <div style={{ fontSize: 12.5, color: CINZA_ESC, marginBottom: 12 }}>
          {somenteAbonadas ? `${lista.length} falta(s) abonada(s)` : `${lista.length} justificativa(s)`}
          {!somenteAbonadas && pendentes > 0 && (
            <> · <b style={{ color: "#B45309" }}>{pendentes} aguardando decisão</b></>
          )}
          {!somenteAbonadas && lista.filter((x) => x.documentoUrl).length > 0 && (
            <> · {lista.filter((x) => x.documentoUrl).length} com documento anexado</>
          )}
        </div>
      )}

      {lista === null ? (
        <div style={{ color: CINZA_ESC, fontSize: 14, padding: "20px 0" }}>Carregando…</div>
      ) : erro ? (
        <div style={{ color: "#DC2626", fontSize: 14, padding: "20px 0" }}>{erro}</div>
      ) : lista.length === 0 ? (
        <div style={{ color: CINZA_ESC, fontSize: 14, padding: "20px 0", background: "#F8FAFC", border: "1px dashed #CBD5E1", borderRadius: 10, textAlign: "center" }}>
          {somenteAbonadas
            ? "Nenhuma falta abonada no núcleo ainda."
            : todasAsModalidades ? "Nenhuma justificativa pedida no núcleo ainda." : "Nenhuma justificativa pedida nesta modalidade ainda."}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {lista.map(s => {
            const st = (s.status || "").toLowerCase();
            return (
              <div key={s.id} style={{ border: "1px solid #E5E7EB", borderRadius: 10, padding: 14, background: BRANCO }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: somenteAbonadas ? 0 : 6 }}>
                  <span style={{ fontWeight: 800, fontSize: 14, color: TEXTO }}>{s.atletaNome || "Atleta"}</span>
                  {todasAsModalidades && s.modalidade && (
                    <span style={{ fontSize: 11, fontWeight: 700, padding: "2px 8px", borderRadius: 20, background: "#EAF0FA", color: "#24417D" }}>{s.modalidade}</span>
                  )}
                  <span style={{ fontSize: 12, color: CINZA_ESC }}>
                    {s.origem === "portal_presenca" ? "Presença: " : "Treino: "}{fmtData(s.dataTreino)}
                  </span>
                  {st && (
                    <span style={{ fontSize: 10.5, fontWeight: 700, padding: "2px 8px", borderRadius: 20, background: "#F1F5F9", color: STATUS_COR[st] || CINZA_ESC }}>
                      {STATUS_ROTULO[st] || s.status}
                    </span>
                  )}
                </div>

                {/* O motivo e o atestado só no recorte completo. Para a
                    preparação física, a linha acima já diz tudo o que ela
                    precisa para acertar a frequência do setor. */}
                {!somenteAbonadas && (
                  <>
                    {s.justificativa && (
                      <div style={{ fontSize: 13, color: TEXTO, marginBottom: 8, lineHeight: 1.5 }}>{s.justificativa}</div>
                    )}
                    {s.documentoUrl ? (
                      <a href={s.documentoUrl} target="_blank" rel="noopener noreferrer"
                        style={{ display: "inline-block", fontSize: 13, fontWeight: 700, color: AZUL, textDecoration: "none" }}>
                        {s.origem === "portal_presenca" ? "📷 Ver foto do registro" : "📎 Ver comprovante anexado"}
                      </a>
                    ) : (
                      <span style={{ fontSize: 12.5, color: CINZA_ESC }}>Sem documento anexado</span>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
